import * as React from 'react';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';

import {
  errorColor,
  gray100,
  gray90,
  primaryColor
} from '../../constants/Colors';
import { formLabelWrapper } from '../../constants/Location';

import type { FieldError } from 'react-hook-form';

type radioProps = React.ComponentProps<typeof RadioGroup>;

type Props = radioProps & {
  disabled?: boolean;
  disabledColor?: string;
  error?: boolean;
  helperText?: FieldError | string | undefined;
  labelText?: string;
  options: { label: string | React.ReactNode; value: number }[];
  requiredText?: string;
  width?: string;
  formMb?: string;
};

const CustomRadioButton = React.forwardRef<HTMLDivElement, Props>(
  (props: Props, ref): React.ReactElement => {
    const {
      disabled,
      disabledColor,
      error,
      helperText,
      labelText,
      options,
      requiredText,
      formMb,
      ...rest
    } = props;

    const textfieldHelper = (): string | undefined => {
      if (helperText === undefined) return;
      return String(helperText);
    };

    const styles = {
      formLabelWrapper,
      helper: {
        '@media screen and (max-width:480px)': {
          marginLeft: 0
        },
        marginLeft: 0
      },
      label: {
        fontSize: '14px'
      },
      radio: {
        '&.Mui-checked': {
          color: primaryColor
        },
        color: gray90
      },
      radioLabel: {
        '& .Mui-disabled': {
          WebkitTextFillColor: disabledColor ?? 'initial'
        },
        color: gray100
      },
      required: {
        color: errorColor,
        fontSize: '14px',
        marginLeft: '8px'
      },
      formMb: { marginBottom: formMb ?? '8px' }
    };

    return (
      <Typography align="center" component="div" sx={styles.formMb}>
        <Typography align="left" component="div">
          <Typography color={gray100} component="span" sx={styles.label}>
            {labelText}
          </Typography>
          {requiredText && (
            <Typography component="span" sx={styles.required}>
              {requiredText}
            </Typography>
          )}
        </Typography>
        <Typography align="left" component="div">
          <FormControl>
            <RadioGroup {...rest} value={rest.value ?? options[0].label}>
              {options &&
                options.map((option, index) => (
                  <FormControlLabel
                    {...(disabled && { disabled })}
                    control={<Radio sx={styles.radio} />}
                    key={index}
                    label={option.label}
                    ref={ref}
                    sx={styles.radioLabel}
                    value={option.value}
                  />
                ))}
            </RadioGroup>
          </FormControl>
        </Typography>
        <FormHelperText error={error} sx={styles.helper}>
          {textfieldHelper()}
        </FormHelperText>
      </Typography>
    );
  }
);
CustomRadioButton.displayName = 'CustomRedioButton';
export default CustomRadioButton;
